import { createSelector } from '@ngrx/store';
import {
  selectCartList,
  selectCartTotals,
} from './cart.selectors';
import { selectCoupon } from './coupon.selectors';
import { selectDeliveryZone } from './delivery-zone.selectors';
import { selectLocalChannelId } from './local-channel.selectors';
import { selectOrderType } from './order-type.selectors';
import { selectTipDetail } from './tip.selectors';

import {
  selectClient,
  selectClientLocation,
  selectClientForm,
  selectApartmentOrSuite,
  selectDeliveryInstructions,
} from './client.selectors';
import { selectPaymentMethod } from './checkout.selectors';
import { selectStore } from './store.selectors';
import { OrderForm, OrderFormUserData, OrderType, WorkDay } from '@core/models';
import { LanguajeEnum } from '@core/enums';

export const selectOrdenForm = createSelector(
  selectCartList,
  selectLocalChannelId,
  selectStore,
  selectOrderType,
  selectClient,
  selectClientLocation,
  selectDeliveryZone,
  selectTipDetail,
  selectPaymentMethod,
  selectCartTotals,
  selectClientForm,
  selectApartmentOrSuite,
  selectDeliveryInstructions,
  selectCoupon,
  (
    cartList,
    localChannelId,
    storeData,
    typeOrder,
    auth,
    userLocation,
    deliveryZone,
    tipDetail,
    paymentMethod,
    cartTotals,
    clientPersonalInformation,
    apartmentOrSuite,
    deliveryInstructions,
    coupon
  ): OrderForm => {
    return {
      cartList: cartList ?? [],
      localChannelId: typeof localChannelId === 'string' ? localChannelId : '',
      storeData: storeData!,
      typeOrder: { nombre: typeOrder } as OrderType,
      auth: auth ?? null,
      userLocation: userLocation ?? null,
      languaje: LanguajeEnum.es,
      workDay: null as unknown as WorkDay,
      statusOrder: null,
      deliveryZoneList: deliveryZone ? [deliveryZone] : [],
      tipDetail: tipDetail ?? null,
      paymentMethod: paymentMethod ?? 'cash',
      cartTotals: cartTotals!,
      userData: {
        ...clientPersonalInformation,
        apartmentOrSuite,
        deliveryInstructions,
      } as OrderFormUserData,
      deliveryAddress: userLocation?.address || '',
      paymentCard: null,
      ConfiguracionCanal: [],
      coupon: coupon ?? null,
    };
  }
);
